// disableCheckoutButton();

// window.addEventListener('load', function() {
//   console.log('## All Scripts loaded ##');
//   activateCheckoutButton();
// })

window.onload = function() { 
    jQuery.getJSON('/cart', function(e){
      var items = e.items;
      for (var i in items) {
        if(items[i].title === "Pickup Instore") {
          var tt = setInterval(function(){disableCheckoutButton();}, 1000);
          setTimeout(function() { clearInterval(tt); }, 5000);        	
        }
      }
    })
    
     
  };
document.addEventListener('crPickupActivated', function (e) { 
    console.log('____ activated _____');
    var tt = setInterval(function(){disableCheckoutButton();}, 1000);
    setTimeout(function() { clearInterval(tt); }, 5000);    
    disableCheckoutButton();

  jqCR('#pickup-date-start, #note-pickup-date, #pickup-first-name, #pickup-last-name, #pickup-number').on('mouseout keyup change', function(){
  	console.log('check for others and activate checkout')  	
    checkPickupFields()
  })
  
  jqCR(document).on('change', '#note-pickup-date', function(){
  console.log('========== change');
  checkPickupFields()
})
// Just pass an element to the function to start tracking
trackChange( jqCR("#note-pickup-date")[0] );
  
  });


MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var trackChange = function(element) {
  var observer = new MutationObserver(function(mutations, observer) {
    if(mutations[0].attributeName == "value") {
        jqCR(element).trigger("change");
    }
  });
  observer.observe(element, {
    attributes: true
  });
}

function checkPickupFields(){
  	var pickupDate = jqCR('#pickup-date-start').val();
    var firstName = jqCR('#pickup-first-name').val();
    var lastName = jqCR('#pickup-last-name').val();
    var phone = jqCR('#pickup-number').val();
    if (pickupDate) {
    	activateCheckoutButton();
    } else {
    	disableCheckoutButton()
    }
}

function activateCheckoutButton(){
    console.log('activate!!')
    //jqCR('[name=checkout]').removeAttr('disabled');
    //$('[name=chekout]').removeAttr('disabled');
    document.querySelector('#checkout').disabled = false;
  }

function disableCheckoutButton(){    
    console.log('disable')
    document.querySelector('#checkout').disabled = true;
    //jqCR('[name=checkout]').attr('disabled', 'disabled');
    //$('[name=chekout]').attr('disabled', 'disabled');
  }